import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Loader from "./components/Loader";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Doctor from "./components/Doctor";
import WhyChooseUs from "./components/WhyChooseUs";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "DentalClinic",
      "@id": "https://drsainulabidiqra.in/#clinic",
      "name": "Dr. Sainulabid's IQRA Multispeciality Dental Clinic",
      "image": "https://drsainulabidiqra.in/logo512.png",
      "url": "https://drsainulabidiqra.in",
      "telephone": "+918590300370",
      "priceRange": "₹₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Near PMSA Yatheemkhana, Kattilangadi",
        "addressLocality": "Athavanad",
        "addressRegion": "Kerala",
        "postalCode": "676301",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "10.898543",
        "longitude": "76.007616"
      },
      "openingHours": "Mo-Sa 09:00-19:30",
      "areaServed": [
        "Athavanad",
        "Kattilangadi",
        "Kurumbathur",
        "Valanchery",
        "Kuttippuram",
        "Pattarnadakavu",
        "Thirunavaya",
        "Puthanathani",
        "Malappuram"
      ]
    });

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  if (loading) return <Loader />;

  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Doctor />
      <WhyChooseUs />
      <Gallery />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
      <FloatingButtons />
    </>
  );
}

export default App;